document.addEventListener("DOMContentLoaded", function(){
  var target = document.querySelector(".PageContent");
  function deliveryDateLayout() {
    var insertParent = document.querySelector(".Cart__Recap");
    var insertPosition = document.querySelector(".Cart__Checkout");
    var deliveryDateWrapper = document.querySelector("#deliveryDate__wrapper");
    insertParent.insertBefore(deliveryDateWrapper, insertPosition);
  };
  var observer = new MutationObserver(function(records) {
    records.forEach(function(record) {
      if(record.addedNodes[0].classList.contains("Cart")){
        deliveryDateLayout();
        observer.disconnect();
      }
    });
  });
  var config = { childList: true, characterData: true, subtree: true };
  observer.observe(target, config);
});